import { useMutation, useQuery } from "@tanstack/react-query";
import { submitRedeemLookup, validateRedeemCode } from "@/api/redeem";
import type { RedeemSubmitResult } from "@/interfaces/redeem";

/**
 * Validate the campaign code on page load. `isError` ⇒ the code is unknown (404) → the page shows
 * its invalid-code state. A code's validity doesn't change within a session, so it never refetches,
 * and a 404 must not be retried (`retry: false`).
 */
export function useRedeemCodeValid(code: string) {
  return useQuery({
    queryKey: ["redeem", "validate", code],
    queryFn: () => validateRedeemCode(code),
    enabled: code.length > 0,
    retry: false,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });
}

/** Submit the recipient's email for lookup + gift-email resend within this campaign. */
export function useSubmitRedeem(code: string) {
  return useMutation<RedeemSubmitResult, Error, string>({
    mutationFn: (email: string) => submitRedeemLookup(code, email),
  });
}
